<template>
  <v-form v-model="valid" ref="form" lazy-validation v-if="clip_export">
    <v-toolbar :color="$dark() ? 'grey darken-4' : 'deep-orange'" dark>
      <v-toolbar-title>Export "{{clip_title}}" to {{settings.name}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-layout row wrap style="height: auto;">
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-list subheader v-show="!settings_value.form.hide_quality_selector">
            <v-subheader>Select qualities</v-subheader>
            <v-list-tile class="small" v-for="(quality,index) in qualities" :key="quality.uuid" @click="">
              <v-list-tile-action @click="select_quality(quality.uuid)"><v-checkbox v-model="selected_qualities" :value="quality.uuid"></v-checkbox></v-list-tile-action>
              <v-list-tile-content @click="select_quality(quality.uuid)">
                <v-list-tile-title>{{ get_quality_title(quality, "") }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ get_quality_subtitle(quality, "") }}</v-list-tile-sub-title>
              </v-list-tile-content>

            </v-list-tile>
          </v-list>

          <component v-for="elem in form.left" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="clip_export.form_data">
            <v-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
              <component v-bind:is="celem.type" v-bind="celem" v-model="clip_export.form_data"></component>
            </v-flex>
          </component>
        </v-flex>
        <v-flex xs6 style="padding-bottom: 5px;" pl-1>
          <component v-for="elem in form.right" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="clip_export.form_data">
            <v-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
              <component v-bind:is="celem.type" v-bind="celem" v-model="clip_export.form_data"></component>
            </v-flex>
          </component>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <span v-if="!is_valid_selected_qualities" class="error--text pl-2 font-italic">This clip doesn't have required qualities</span>
      <v-spacer></v-spacer>
			<v-btn color="deep-orange" dark @click="export_clip" :disabled="!is_valid_selected_qualities">Export</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import * as FormItems from '@/components/form_items'
import SettingsModel from '@/models/settings.js'
import ClipModel from '@/models/clip.js'
import EventModel from '@/models/event.js'
import moment from 'moment'

export default {
  props: ['qualities', 'settings_id', 'event_uuid'],
  components: {
    ...FormItems
  },
  data() {
    var ch = this.$cloudserver.channel("events:clip_export:create");
    var settings = (SettingsModel.get_by_id(this.settings_id)||{}).value || {}
    var qualities = _.filter(this.qualities, (q) => { return (settings.form.pre_selected_qualities||[]).indexOf(this.get_quality_name(q)) != -1; });
    return {
      ws_channel: ch,
      selected_qualities: _.map(qualities, (q) => { return q.uuid; }),
      clip_export: this.convertClipExport(ch.data),
      valid: false
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.clip_export = this.convertClipExport(newVal, oldVal);
        }
      },
      deep: true
    },
  },
  computed: {
    form () {
      return (this.settings_value.form||{}).fields || [];
    },
    settings () {
      return SettingsModel.get_by_id(this.settings_id);
    },
    settings_value() {
      return (this.settings||{}).value || {}
    },
    clip_title() {
      return _.get(this.qualities[0], "meta.title", "")
    },
    selected_qualities_names() {
      return _.map(_.filter(this.qualities, (q) => { return this.selected_qualities.indexOf(q.uuid) != -1; }), (q) => { return this.get_quality_name(q); });
    },
    required_qualities() {
      return _.get(this.settings_value, "form.required_qualities", []);
    },
    is_valid_selected_qualities() {
      return this.required_qualities.every(q=> this.selected_qualities_names.indexOf(q) !== -1);
    },
    default_value_functions() {
      var self = this;
      return {
        event_start_plus_clip_start (event, clip, info) {
          return event.cached_start_time + clip.start_time;
        },
        event_start_plus_clip_end (event, clip, info) {
          return event.cached_start_time + clip.end_time;
        },
        from_event(event, clip, info) {
          return _.get(event, info.key, info.default_value);
        },
        from_clip(event, clip, info) {
          return _.get(clip, info.key, info.default_value);
        }
      }
    }
  },
  methods: {
    export_clip() {
      if (!this.$refs.form.validate() && this.selected_qualities.length) {
        return;
      }

      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var clip_export = _.cloneDeep(this.clip_export);
        delete clip_export.form_data.__event__;

        var export_configuration_ids = _.get(this.settings, "value.export_configuration_id");

        var save = (export_configuration_id) => {
          return new Promise((resolve, reject) => {
            clip_export.clip_uuids = this.selected_qualities;
            clip_export.meta.export_configuration_id = _.get(export_configuration_id, "id", export_configuration_id);
            clip_export.meta.destination = this.settings.name;
            clip_export.event_uuid = this.event_uuid

            clip_export.meta.title = _.get(this.qualities[0], "meta.title", "");
            if(_.has(export_configuration_id, "name")) {
              clip_export.meta.title += " (" + _.get(export_configuration_id, "name", "") + ")";
            }

    				this.ws_channel.save({clip_export: clip_export})
    					.then(() => {
                resolve(export_configuration_id)
              })
    					.catch(() => {
                reject(export_configuration_id)
              });
          });
        }

        if(_.isArray(export_configuration_ids)) {
          Promise.allSettled(_.map(export_configuration_ids, save)).then((results) => {
            _.each(results, (result) => {
              if(result.status == "fulfilled") {
                self.$message.success("Exporting clip ("+_.get(result, "value.name", "")+")!");
              } else {
                self.$message.warning("Unable to export clip ("+_.get(result, "reason.name", "")+")!");
              }
            });

            self.$emit("input", false);
          })
        } else if(_.isNumber(export_configuration_ids)) {
          save(export_configuration_ids).then(() => {
            self.$message.success("Exporting clip!");
            self.$emit("input", false);
          }).catch((result) => {
            console.log(result)
            self.$message.warning("Unable to export clip!");
            self.$emit("input", false);
          });
        }
      }
    },

    get_event(cb) {
      var channel = this.$cloudserver.channel("events:"+this.event_uuid, false);
      var on_init_ref;
      on_init_ref = channel.on("data", function(msg) {
        channel.off("data", on_init_ref);
        channel.leave();
        if(_.isEmpty(channel.data)) cb(msg.data);
      });
      channel.join();
      if(!_.isEmpty(channel.data)) {
        cb(channel.data);
        channel.off("data", on_init_ref);
        channel.leave();
      }
    },
    convertClipExport (newVal, oldVal) {
			var clip_export = _.cloneDeep(newVal);
			if(typeof(oldVal) != "undefined") {
				//TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
			}

			if(typeof(clip_export) == "undefined" || _.isEmpty(clip_export)) return undefined;

      var form_data = {};
      this.get_event((event) => {
        _.each([].concat(this.form.left,this.form.right), (field) => {
          if(typeof(field.default_value) == "object" && field.default_value.type == "function" && typeof(this.default_value_functions[field.default_value.function]) == "function") {
            form_data[field.name] = this.default_value_functions[field.default_value.function](event, this.qualities[0], field.default_value);
          } else if(field.default_value) {
            form_data[field.name] = field.default_value;
          } else {
            if(field.type == "date-time") {
              form_data[field.name] = moment().unix();
            } else if(field.type == "check-box") {
              form_data[field.name] = false;
            } else {
              form_data[field.name] = null;
            }
          }
        });
        form_data.__event__ = event;
        clip_export.form_data = form_data;
      });

			return clip_export;
		},
    row_classes(childs) {
      return "xs" + Math.round(12/childs.length);
    },
    get_quality_title(clip, default_text) {
      return ClipModel.get_title(clip, default_text)
    },
    get_quality_subtitle(clip, default_text) {
      return ClipModel.get_subtitle(clip, default_text)
    },
    get_quality_name(clip) {
      return ClipModel.get_name(clip);
    },
    select_quality(uuid) {
      var index = this.selected_qualities.indexOf(uuid);

      if (index === -1) {
          this.selected_qualities.push(uuid);
      } else {
          this.selected_qualities.splice(index, 1);
      }
    }
  },
  created() {
    this.ws_channel.join();
  }
}
</script>
